import React, { useEffect, useState, useMemo, useRef } from 'react'
import { Input, Button, Modal, Table, Tooltip, message, Select } from 'antd'
import Highlighter from 'react-highlight-words'
import _ from 'lodash'

import { getEstimateFieldByProject } from '../../../services/estimate-field'
//import useCategory from '../../hooks/useCategory'
import useCategory from '../../../app/hooks/useCategory'

import styles from './style.module.css'
import {
  DECIMAL_FORMAT,
  formatDecimalAmount,
  formatMoney,
  formatNumberByMask,
  MONEY_FORMAT,
} from '../../../utils/number-utils'

const { Search } = Input

const PAGE_SIZE = 10

const numberCellStyle = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  overflowWrap: 'normal',
}

const EstimateItemInput = ({ project, value = {}, loadOnPress = false, onChange, onEstimateSelect }) => {
  const inputRef = useRef(null)
  const [categories] = useCategory(project)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [searchValue, setSearchValue] = useState('')
  const [ds, setDs] = useState({
    data: [],
    page: null,
    search: '',
    categories: [],
  })
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(1)
  const [selectedCategories, setSelectedCategories] = useState([])

  const pagination = useMemo(
    () => ({
      current: page,
      pageSize: PAGE_SIZE,
      total: count,
      onChange: setPage,
      showSizeChanger: false,
      showTotal: (total, range) => `${range[0]}-${range[1]} из ${total}`,
    }),
    [count, page]
  )

  useEffect(() => {
    if (inputRef && inputRef.current && isModalOpen) {
      if (ds.page == null && loadOnPress) {
        setIsLoading(true)
        loadData()
          .catch(() => message.error('Ошибка загрузки контента'))
          .finally(() => setIsLoading(false))
      }
      setTimeout(() => {
        inputRef.current.focus({
          cursor: 'start',
        })
      }, 250)
    }
  }, [isModalOpen])

  const onOpenPress = () => setIsModalOpen(true)
  const handleCancel = () => setIsModalOpen(false)
  const onSearchChange = (e) => {
    setSearchValue(e.target.value)
    setPage(1)
  }

  const loadData = async () => {
    const response = await getEstimateFieldByProject(project, searchValue, selectedCategories, {
      page,
      pageSize: PAGE_SIZE,
    })
    if (response && response.status === 200 && response.data) {
      setDs({
        data: response.data?.data?.attributes?.results,
        categories: selectedCategories,
        search: searchValue,
        page,
      })
      setCount(response.data?.data?.attributes?.pagination?.total)
    }
  }

  useEffect(() => {
    if (
      project &&
      ((ds.page != null && ds.page !== page) ||
        !_.isEqual(ds.categories, selectedCategories) ||
        ds.search !== searchValue)
    ) {
      setIsLoading(true)
      loadData()
        .catch(() => message.error('Ошибка загрузки контента'))
        .finally(() => setIsLoading(false))
    }
  }, [project, searchValue, selectedCategories, page, ds])

  const onCategoriesChange = (values) => {
    setSelectedCategories(values)
    setPage(1)
  }

  const columns = [
    {
      title: '№',
      dataIndex: 'id',
    },
    {
      title: 'Наименование',
      dataIndex: 'name',
      render: (name) => <Highlighter searchWords={searchValue.split(' ')} autoEscape textToHighlight={name} />,
    },
    {
      title: 'Цена',
      dataIndex: 'price',
      render: (value) => <div style={{ whiteSpace: 'nowrap' }}>{formatMoney(value)}</div>,
    },
    {
      title: 'Кол-во',
      dataIndex: 'amount',
      render: (value) => <div style={numberCellStyle}>{formatDecimalAmount(value)}</div>,
    },
    {
      title: 'Категория',
      dataIndex: 'category',
    },
    {
      title: 'Ед. Изм.',
      dataIndex: 'unit',
    },
  ]

  return (
    <>
      <Tooltip trigger={['hover']} title={value?.value} placement="top">
        <Input.Group style={{ minWidth: 350, maxWidth: 450, display: 'flex' }}>
          <Input
            allowClear
            value={value?.value}
            onChange={() => {
              onChange({})
              onEstimateSelect && onEstimateSelect({})
            }}
          />
          <Button onClick={onOpenPress}>...</Button>
        </Input.Group>
      </Tooltip>
      <Modal width={1200} title="Выбор позиции из сметы" visible={isModalOpen} onCancel={handleCancel} footer={null}>
        <div className={styles.search}>
          <Search
            ref={inputRef}
            style={{ flex: 1 }}
            placeholder="Введите название позиции"
            onChange={onSearchChange}
            loading={isLoading}
          />
          <Select
            style={{ flex: 1, marginLeft: 15 }}
            mode="multiple"
            allowClear
            options={categories.map((category) => ({
              value: category,
              label: category,
            }))}
            placeholder="Выберите категорию"
            dropdownMatchSelectWidth={false}
            onChange={onCategoriesChange}
          />
        </div>
        <Table
          style={{ paddingTop: 20, cursor: 'pointer' }}
          size="small"
          columns={columns}
          dataSource={ds.data}
          pagination={pagination}
          onRow={(record, rowIndex) => ({
            onClick: (event) => {
              setIsModalOpen(false)
              onChange({
                key: record.id,
                value: record.name,
              })
              if (onEstimateSelect) {
                onEstimateSelect(record)
              }
            },
          })}
        />
      </Modal>
    </>
  )
}

export default EstimateItemInput
